// Handing a file to the phone's own share sheet (WhatsApp, Viber, mail…): the file itself,
// never a link. Where a browser cannot share files the file is downloaded instead.
import { downloadBlob } from './download.ts'

/** Whether this browser can hand `file` to the share sheet. */
export function canShareFile(file: File): boolean {
  try {
    return typeof navigator.share === 'function' && navigator.canShare?.({ files: [file] }) === true
  } catch {
    return false
  }
}

/**
 * Shares `file`, or downloads it where sharing files is not possible. Resolves `'shared'`,
 * `'downloaded'` or `'closed'` (the person closed the share sheet: nothing to say).
 * Must run straight from a tap: make the file before, never in between.
 */
export async function shareFile(file: File): Promise<'shared' | 'downloaded' | 'closed'> {
  if (!canShareFile(file)) {
    downloadBlob(file, file.name)
    return 'downloaded'
  }
  try {
    await navigator.share({ files: [file] })
    return 'shared'
  } catch (error) {
    if (error instanceof DOMException && error.name === 'AbortError') return 'closed'
    throw error
  }
}
